module.exports = __webpack_public_path__ + "assets/img/ic-lock-red.7f853767.svg";